import { connect } from 'react-redux';
import { clearInventoryAuditLogs } from '../../../redux/Inventory/actions/audit-log';
import {
  updateAuditLogsSearchQuery,
  resetAuditLogsSearchQuery
} from '../../../redux/Inventory/actions/components/audit-log-search';
import { getIsFetching as getIsFetchingAuditLogs } from '../../../redux/Inventory/selectors/audit-log';
import {
  getUserSearchOptions,
  getItemSearchOptions,
  getLocationSearchOptions,
  getZoneSearchOptions,
  getTagSearchOptions,
  getIsFetching as getIsFetchingSearchOptions
} from '../../../redux/Inventory/selectors/audit-log/search-option';
import { getAuditLogSearchQuery } from '../../../redux/Inventory/selectors/components/audit-log-search';
import {
  fetchInventoryAuditLogs,
  fetchInventoryAuditLogsSearchOptions
} from '../../../redux/Inventory/sagas/audit-log/routines';
import InventoryAuditLogSearch from '../../../components/inventory/AuditLogSearch';

function mapStateToProps(state, props) {
  return {
    ...props,
    query: getAuditLogSearchQuery(state),
    userOptions: getUserSearchOptions(state),
    itemOptions: getItemSearchOptions(state),
    locationOptions: getLocationSearchOptions(state),
    zoneOptions: getZoneSearchOptions(state),
    tagOptions: getTagSearchOptions(state),
    isFetching:
      getIsFetchingSearchOptions(state) || getIsFetchingAuditLogs(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchInventoryAuditLogsSearchOptions());
    },
    onChange: query => {
      dispatch(updateAuditLogsSearchQuery(query));
    },
    onSubmit: query => {
      dispatch(clearInventoryAuditLogs());
      dispatch(fetchInventoryAuditLogs(query));
    },
    onReset: () => {
      dispatch(resetAuditLogsSearchQuery());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAuditLogSearch);
